export default __webpack_public_path__ + "static/media/2388.6a88d3f7.png";